import { jsxs as n, Fragment as c, jsx as i } from "react/jsx-runtime";
import "react";
import { classes as t } from "../../utils/helpers.js";
import '../../assets/LogoListItem.css';const s = {
  "icon-list-item": "_icon-list-item_8ortj_1",
  "icon-list-item__link": "_icon-list-item__link_8ortj_21",
  "icon-list-item__img-wrapper": "_icon-list-item__img-wrapper_8ortj_22"
};
function p({ imageSource: m, href: l = "", altText: e = "", target: o = "_self" }) {
  return /* @__PURE__ */ n(c, { children: [
    l !== "" && /* @__PURE__ */ i("li", { className: t([s["icon-list-item"], "icon-list-item"]), children: /* @__PURE__ */ n(
      "a",
      {
        href: l,
        className: t([s["icon-list-item__link"], "icon-list-item__link"]),
        target: o,
        children: [
          /* @__PURE__ */ i("span", { className: "sr-only", children: e }),
          /* @__PURE__ */ i("img", { src: m, alt: `${e} logo`, className: s["ion-list-item__image"] })
        ]
      }
    ) }),
    l === "" && /* @__PURE__ */ i("li", { className: t([s["icon-list-item"], "icon-list-item"]), children: /* @__PURE__ */ i("span", { className: t([s["icon-list-item__img-wrapper"], "icon-list-item__img-wrapper"]), children: /* @__PURE__ */ i("img", { src: m, alt: `${e} logo` }) }) })
  ] });
}
export {
  p as LogoListItem,
  p as default
};
